import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.SubscriptionsSettings";
export const messages = defineMessages({
  subscriptionName: {
    id: `${PREFIX}.subscriptionName`,
    defaultMessage: "Subscription name",
  },
  saveDate: {
    id: `${PREFIX}.saveDate`,
    defaultMessage: "Save date",
  },
  slideName: {
    id: `${PREFIX}.slideName`,
    defaultMessage: "Slide",
  },
  bulkExportSource: {
    id: `${PREFIX}.bulkExportSource`,
    defaultMessage: "Bulk export source",
  },
  savedBulkExport: {
    id: `${PREFIX}.savedBulkExport`,
    defaultMessage: "Saved bulk export",
  },
  selections: {
    id: `${PREFIX}.selections`,
    defaultMessage: "Selections",
  },
  fileFormat: {
    id: `${PREFIX}.fileFormat`,
    defaultMessage: "File format",
  },
  frequencyParameters: {
    id: `${PREFIX}.frequencyParameters`,
    defaultMessage: "Subscription frequency parameters",
  },
});
